import 'antd/dist/antd.css';

import { Layout, Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import Environment from '../components/Environment';
import GreetingUser from '../components/GreetingUser';
import ProvedorContextos from '../components/ProvedorContextos';
import ProtectedRoute from '../components/Security/ProtectedRoute';
import SideBar from '../components/SideBar';
import { pageView } from '../helpers/googleAnalytics';
import { getCnpjResumido } from '../helpers/shipper';
import CadastroCliente from '../pages/CadastroCliente';
import ListagemClientes from '../pages/CadastroCliente/ListagemClientes';
import FormularioGrupoFrotista from '../pages/CadastroGrupoFrotista/FormularioGrupoFrotista';
import ListagemGrupoFrotista from '../pages/CadastroGrupoFrotista/ListagemGrupoFrotista';
import CadastroUsuario from '../pages/CadastroUsuario';
import ListagemUsuarios from '../pages/CadastroUsuario/ListagemUsuarios';
import CadastroCotacao from '../pages/Cotacoes/Cadastro';
import { Finished as CadastroCotacaoFinished } from '../pages/Cotacoes/Cadastro/Finished';
import Detalhes from '../pages/Cotacoes/Detalhes';
import Cotacoes from '../pages/Cotacoes/Listagem';
import DashboardPerformance from '../pages/DashboardPerformance';
import Dashboards from '../pages/Dashboards';
import CadastroDemanda from '../pages/Demanda/Cadastro';
import Detalhe from '../pages/Demanda/Detalhe';
import ListagemDemanda from '../pages/Demanda/Listagem';
import DetalhesLote from '../pages/DetalhesLote';
import { Login } from '../pages/Login';
import CadastroCsv from '../pages/Lote/CadastroCsv';
import CadastroLote from '../pages/Lote/CadastroManual';
import DocumentacaoApi from '../pages/Lote/DocumentacaoApi';
import MapaGerenciamento from '../pages/MapaGerenciamento';
import PainelEmbarque from '../pages/PainelEmbarque';
import PerfilUsuario from '../pages/PerfilUsuario';
import Precificacao from '../pages/Precificacao';
import Precificacao2 from '../pages/Precificacao2';
import PrimeiroAcesso from '../pages/PrimeiroAcesso';
import RelatorioViagens from '../pages/Relatorios/Viagens';
import { AuthConsumer } from '../security/authContext';
import Can from '../security/Can';
import { validaAcessoMenu } from './menus/validador';
import { Provedores } from './provedores';

const { Content, Header } = Layout;
const PrivateRoute = ({ component: Component, mediaQuerys, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      pageView(props.location.pathname);
      return (
        <AuthConsumer>
          {({ authenticated, user }) => {
            if (authenticated) {
              return (
                <Can
                  profile={user.profile}
                  permissions={user.permissions}
                  perform={rest.permissoes_que_habilitam_menu}
                  data={rest.data}
                  no={() => (
                    <Redirect to={validaAcessoMenu(user) || '/perfil'} />
                  )}
                  yes={() => (
                    <ProvedorContextos components={Provedores}>
                      <Layout style={{ height: '100vh' }}>
                        <SideBar {...props} />
                        <Layout className="site-layout">
                          <Header>
                            <Row>
                              <Environment
                                env={process.env.REACT_APP_NODE_ENV}
                              />
                              <GreetingUser
                                name={localStorage.getItem('name')}
                                nomeAlternado={localStorage.getItem(
                                  'nameUsuarioAlternado'
                                )}
                              />
                            </Row>
                          </Header>
                          <Content>
                            <Component {...props} mediaQuerys={mediaQuerys} />
                          </Content>
                        </Layout>
                      </Layout>
                    </ProvedorContextos>
                  )}
                />
              );
            }
            return <Redirect to="/" />;
          }}
        </AuthConsumer>
      );
    }}
  />
);

const Routes = () => (
  <Switch>
    <PrivateRoute
      exact
      path="/painel-embarque"
      permissoes_que_habilitam_menu={['painel-embarque:show']}
      component={PainelEmbarque}
    />
    <PrivateRoute
      exact
      path="/usuarios/novo"
      permissoes_que_habilitam_menu={['cadastro-usuario:show']}
      data={{
        cliente_cnpj_resumido: getCnpjResumido(),
      }}
      component={CadastroUsuario}
    />
    <PrivateRoute
      path="/usuarios/:userId"
      permissoes_que_habilitam_menu={['cadastro-usuario:show']}
      data={{
        cliente_cnpj_resumido: getCnpjResumido(),
      }}
      component={CadastroUsuario}
    />
    <PrivateRoute
      exact
      path="/usuarios"
      permissoes_que_habilitam_menu={['cadastro-usuario:show']}
      data={{
        cliente_cnpj_resumido: getCnpjResumido(),
      }}
      component={ListagemUsuarios}
    />
    <PrivateRoute
      path="/clientes/:cnpj_resumido"
      permissoes_que_habilitam_menu={['cadastro-cliente:show']}
      data={{
        cliente_cnpj_resumido: getCnpjResumido(),
      }}
      component={CadastroCliente}
    />
    <PrivateRoute
      exact
      path="/clientes"
      permissoes_que_habilitam_menu={['cadastro-cliente:show']}
      data={{
        cliente_cnpj_resumido: getCnpjResumido(),
      }}
      component={ListagemClientes}
    />
    <PrivateRoute
      exact
      path="/dashboard-performance"
      permissoes_que_habilitam_menu={[
        'dashboard-performance:aderencia-carregamento',
        'dashboard-performance:variacao-frete',
      ]}
      component={DashboardPerformance}
    />
    <PrivateRoute
      path="/lotes/novo/csv"
      permissoes_que_habilitam_menu={['lotes:create']}
      component={CadastroCsv}
    />
    <PrivateRoute
      path="/lotes/documentacaoApi"
      permissoes_que_habilitam_menu={['lotes:show']}
      component={DocumentacaoApi}
    />
    <PrivateRoute
      path="/lotes/novo"
      permissoes_que_habilitam_menu={['lotes:create']}
      component={CadastroDemanda}
    />
    <PrivateRoute
      path="/lotes/demanda/:idDemanda"
      permissoes_que_habilitam_menu={['lotes:edit']}
      component={CadastroDemanda}
    />
    <PrivateRoute
      path="/lotes/:loteId"
      permissoes_que_habilitam_menu={['lotes:edit']}
      component={CadastroLote}
    />
    <PrivateRoute
      exact
      path="/demandas"
      permissoes_que_habilitam_menu={['lotes:show']}
      component={ListagemDemanda}
    />
    <PrivateRoute
      exact
      path="/detalhesLote/:loteId"
      permissoes_que_habilitam_menu={['lotes:show']}
      component={DetalhesLote}
    />
    <PrivateRoute
      exact
      path="/detalhesDemanda/:demandaId"
      permissoes_que_habilitam_menu={['lotes:show']}
      component={Detalhe}
    />
    <PrivateRoute
      exact
      path="/mapa-gerenciamento/:search?"
      permissoes_que_habilitam_menu={['mapa-gerenciamento:show']}
      component={MapaGerenciamento}
    />
    <PrivateRoute
      exact
      path="/precificacao/:origem?/:destino?/:produto?"
      permissoes_que_habilitam_menu={['precificacao:show']}
      component={Precificacao}
    />
    <PrivateRoute
      exact
      path="/dash-precificacao"
      permissoes_que_habilitam_menu={['dash-precificacao:show']}
      component={Precificacao2}
    />
    <ProtectedRoute exact path="/perfil" component={PerfilUsuario} />
    <PrivateRoute
      exact
      path="/relatorios-viagens"
      permissoes_que_habilitam_menu={['relatorios-viagens:show']}
      component={RelatorioViagens}
    />
    <Route exact path="/" component={Login} />
    <Route exact path="/primeiro-acesso/:token" component={PrimeiroAcesso} />
    <PrivateRoute
      exact
      path="/grupo-frotista"
      permissoes_que_habilitam_menu={['cadastro-cliente:show']}
      data={{
        cliente_cnpj_resumido: getCnpjResumido(),
      }}
      component={ListagemGrupoFrotista}
    />
    <PrivateRoute
      exact
      path="/grupo-frotista/editar/:grupoFrotistaId"
      permissoes_que_habilitam_menu={['cadastro-cliente:show']}
      component={FormularioGrupoFrotista}
    />
    <PrivateRoute
      exact
      path="/grupo-frotista/novo"
      permissoes_que_habilitam_menu={['cadastro-cliente:show']}
      component={FormularioGrupoFrotista}
    />
    <PrivateRoute
      exact
      path="/cotacao"
      permissoes_que_habilitam_menu={['cotacao:show']}
      component={Cotacoes}
    />
    <PrivateRoute
      exact
      path="/cotacao/criar"
      permissoes_que_habilitam_menu={['cotacao:create']}
      component={CadastroCotacao}
    />
    <PrivateRoute
      exact
      path="/cotacao/criada"
      permissoes_que_habilitam_menu={['cotacao:create']}
      component={CadastroCotacaoFinished}
    />
    <PrivateRoute
      exact
      path="/dashboards"
      // TODO: Implementar permissões corretas
      permissoes_que_habilitam_menu={['cotacao:create']}
      component={Dashboards}
    />
    <PrivateRoute
      exact
      path="/cotacao/:id"
      // TODO: Implementar permissões corretas
      permissoes_que_habilitam_menu={['cotacao:show']}
      component={Detalhes}
    />
  </Switch>
);

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
  mediaQuerys: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
    xxl: PropTypes.bool,
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};

PrivateRoute.defaultProps = {
  mediaQuerys: null,
  location: {
    pathname: '/',
  },
  history: {},
};

export default Routes;
